/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import Alert from './Alert';

const WarningAlert = (props) => {
  return <Alert variant="warning" {...props} />;
};

export default WarningAlert;
